import { PageFields, PageProps, SEO } from '@peerless/data-access/strapi';
import { Metadata, ResolvedMetadata, ResolvingMetadata } from 'next';
import he from 'he';

export const createGenerateMetadata =
  (func: () => Promise<{ data?: PageFields }>) =>
  async (props: PageProps, parent: ResolvingMetadata): Promise<Metadata> => {
    const { data } = await func();
    const parentMetadata = await parent;
    return populateMetadata(data?.page.seo, parentMetadata);
  };

export function populateMetadata(data: SEO | undefined, parent: ResolvedMetadata): Metadata {
  const parentTitle = parent.title?.absolute
    ? he.decode(parent.title?.absolute)
    : parent.title?.absolute;
  if (!data)
    return {
      title: parentTitle,
      description: parent.description,
      metadataBase: parent.metadataBase,
      keywords: parent.keywords,
      openGraph: {
        images: parent.openGraph?.images,
      },
    };
  const { metaTitle, metaImage, metaDescription, canonicalURL, keywords, metaRobots } = data;
  const decodedTitle = he.decode(metaTitle);
  //Basic items for now, we can add more later
  return {
    title: [decodedTitle, parentTitle].join(' | '),
    description: metaDescription || parent.description,
    metadataBase: canonicalURL ? new URL(canonicalURL) : parent.metadataBase,
    keywords: keywords ? keywords.split(',').map(keyword => keyword.trim()) : parent.keywords,
    robots: metaRobots,
    openGraph: {
      images: [metaImage?.url, ...(parent.openGraph?.images || [])].filter(Boolean),
    },
  };
}
